/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Status enum used for SelectionOptions0 = Unreleased

10 = Pending

20 = Approved

30 = Declined

40 = Deleted


 */
export type Statuses = (typeof Statuses)[keyof typeof Statuses];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Statuses = {
  UNRELEASED: 0,
  PENDING: 10,
  APPROVED: 20,
  DECLINED: 30,
  DELETED: 40,
} as const;
